var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('kn-navbar'),_c('v-main',{class:_vm.backgroundColor},[_c('v-scale-transition',{attrs:{"group":""}},[_c('router-view',{key:"app-router"})],1)],1),_c('kn-footer'),_c('kn-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }